import {Typography} from '@mui/material';
import Box from '@mui/material/Box';
import {styled} from '@mui/material/styles';

export const NoDiscountNormalPriceWrapper = styled(Box)(({theme}) => ({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  paddingRight: theme.spacing(0.25)
}));

export const StyledNoDiscountAddToBasketBtn = styled(Box)(({theme}) => ({
  alignItems: 'center',
  display: 'flex',
  color: theme.palette.common.mds_global_color_white,
  borderRadius: '50%',
  fontSize: theme.spacing(1.75),
  '&.updatedQuantityBgColor': {
    background: theme.palette.primary.dark,
    boxShadow: `0 0 0 ${theme.spacing(0.25)} ${theme.palette.common.mds_global_color_white}, 0 0 0 ${theme.spacing(
      0.125
    )} ${theme.palette.primary.dark}`
  },
  '&.normalQuantityBgColor': {
    backgroundColor: theme.palette.primary.main
  },
  width: theme.spacing(4),
  height: theme.spacing(4),
  [theme.breakpoints.down('sm')]: {
    width: theme.spacing(3.5),
    height: theme.spacing(3.5)
  },
  '&.compact': {
    width: theme.spacing(3.5),
    height: theme.spacing(3.5)
  }
}));

export const StyledNoDiscountCurrentPriceSymbolTypography = styled(Typography)(({theme}) => ({
  color: theme.palette.secondary.main,
  fontWeight: 600,
  marginTop: theme.spacing(0.5),
  marginLeft: theme.spacing(0.25),
  fontSize: theme.spacing(1.5),
  lineHeight: theme.spacing(2.27),
  display: 'inline',
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.spacing(1.25),
    lineHeight: theme.spacing(1.89)
  },
  '&.isDiscount': {
    color: '#E82026'
  }
}));

export const StyledNoDiscountCurrentPriceTypography = styled(Typography)(({theme}) => ({
  color: theme.palette.secondary.main,
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.spacing(2.5),
  lineHeight: theme.spacing(3),
  display: 'inline',
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.spacing(2.25),
    lineHeight: theme.spacing(2.7)
  },
  '&.pdp': {
    fontSize: theme.spacing(3),
    lineHeight: theme.spacing(3.5)
  },
  '&.isSearchBoxCarousel': {
    fontSize: '14px'
  },
  '&.isDiscount': {
    color: '#E82026'
  }
}));

export const StyledNoDiscountNormalPrice = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  '&.price': {
    overflow: 'hidden'
  },
  '&.isSearchBoxCarousel': {
    borderRadius: '50%',
    height: 'fit-content',
    position: 'relative',
    left: '47px',
    bottom: '41px'
  },
  '&.isSearchBoxCarouselNoDiscountPrice': {
    height: '10',
    marginTop: '6px'
  }
}));

export const StyledNoDiscountPriceContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  height: theme.spacing(6),
  justifyContent: 'space-between',
  borderRadius: theme.spacing(1),
  background: theme.palette.grey[50],
  padding: theme.spacing(0.5, 1),
  '&.pdp': {
    background: 'none',
    paddingLeft: 0
  },
  '&.addToCart': {
    background: 'rgb(244, 244, 244)',
    padding: '4px 8px'
  },
  [theme.breakpoints.down('sm')]: {
    height: theme.spacing(5.5)
  }
}));

export const StyledUpdatedQuanityTypography = styled(Typography)(({theme}) => ({
  fontSize: theme.spacing(2),
  fontWeight: 600,
  textAlign: 'center',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&.medium': {
    fontSize: theme.spacing(1.75)
  },
  '&.small': {
    fontSize: theme.spacing(1.25)
  },
  '&.extraSmall': {
    fontSize: theme.spacing(1)
  },
  [theme.breakpoints.down('sm')]: {
    '&.medium': {
      fontSize: theme.spacing(1.5)
    },
    '&.small': {
      fontSize: theme.spacing(1)
    },
    '&.extraSmall': {
      fontSize: theme.spacing(0.75)
    }
  }
}));

export const WeightedFreshKgText = styled('span')(({theme}) => ({
  color: theme.palette.grey[400],
  fontWeight: 600,
  fontSize: theme.spacing(1.75),
  paddingLeft: theme.spacing(0.25),
  '&.addToCart, &.pdp': {
    fontSize: theme.spacing(2)
  },
  '&.topPicks': {
    fontSize: theme.spacing(1.45),
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.grey[900]
  },
  '&.isDiscount': {
    fontSize: theme.spacing(1.45),
    fontWeight: theme.typography.fontWeightBold,
    color: '#E82026'
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.spacing(1.5),
    '&.addToCart': {
      fontSize: theme.spacing(1.5)
    }
  }
}));
